import { render, staticRenderFns } from "./ApprovalBox.vue?vue&type=template&id=58d855c1"
import script from "./ApprovalBox.vue?vue&type=script&lang=js"
export * from "./ApprovalBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports